import React, { useRef } from "react";
import emailjs from "emailjs-com";

function Info() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_sbqg0ix", // 🔹 Replace with EmailJS Service ID
        "template_nmqu5s1", // 🔹 Replace with EmailJS Template ID
        e.target,
        "QcFZhYJ0ZFI2BJ1hx" // 🔹 Replace with EmailJS Public Key
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.error("FAILED...", error.text);
          alert("Something went wrong, please try again.");
        }
      );
  };

  return (
    <div
      className="sec-box contact section-padding bord-thin-top mt-20"
      id="info"
    >
      <div className="row">
        <div className="col-lg-5">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title mb-15 opacity-7">Get In Touch</h6>
            <h2 className="fz-50">Let’s Build Something Amazing Together!</h2>
            <p className="fz-15 mt-10">
              I’m a Full Stack and WordPress Developer with 3+ years of
              experience building modern, responsive websites and applications.
              If you’d like to collaborate on a project or just connect, feel
              free to reach out!
            </p>
            <div className="phone fz-30 fw-600 mt-30 underline">
              <a href="tel:+917276389688" className="main-color">
                +91 72763 89688
              </a>
            </div>
            <ul className="rest social-text d-flex mt-60">
              <li className="mr-30">
                <a
                  href="mailto:hingwe90@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover-this"
                >
                  <i className="fas fa-envelope"></i>
                </a>
              </li>
              <li className="mr-30">
                <a href="tel:+917276389688" className="hover-this">
                  <i className="fas fa-phone"></i>
                </a>
              </li>
              <li className="mr-30">
                <a
                  href="https://github.com/nikhilhingwe"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover-this"
                >
                  <i className="fab fa-github"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/nikhil-h-780b681b8/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover-this"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-7 valign">
          <div className="full-width wow fadeIn">
            <form ref={form} onSubmit={sendEmail} id="contact-form">
              <div className="messages"></div>

              <div className="controls row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_name"
                      type="text"
                      name="name"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_email"
                      type="email"
                      name="email"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-30">
                    <input
                      id="form_subject"
                      type="text"
                      name="subject"
                      placeholder="Subject"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      id="form_message"
                      name="message"
                      placeholder="Message"
                      rows="4"
                      required
                    ></textarea>
                  </div>
                  <div className="mt-30">
                    <button type="submit">
                      <span className="text">Send A Message</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
